

import React, { useEffect, useState } from 'react';
import './Header.css'
import { AiFillHome } from 'react-icons/ai';
import { FaUserGraduate } from 'react-icons/fa';
import { AiFillMedicineBox } from 'react-icons/ai';
import { FaBlog } from 'react-icons/fa';
import { AiFillContacts } from 'react-icons/ai';
import { AiFillDashboard } from 'react-icons/ai';
import { Link, NavLink, useLocation } from 'react-router-dom';
import MobileMenu from './MobileMenu';



const Header = ({children}) => {
  const location = useLocation();

    const [dark, setDark] = useState(false);
    const [active, setActive] = useState('home'); // set the initial active state to 'home'

    useEffect(() => {
        // Retrieve the theme preference from localStorage
        const savedTheme = localStorage.getItem('theme');
        if (savedTheme === 'dark') {
          setDark(true);
        }
      }, []);
    
      useEffect(() => {
        // Save the theme preference to localStorage
        localStorage.setItem('theme', dark ? 'dark' : 'light');
      }, [dark]);
   // Check if the current location is a nested route
   const isNestedRoute = location.pathname.includes('/dashboard/');
   
      // define the onClick event listener for each li element
      const handleClick = (item) => {
        setActive(item); // update the active state to the clicked item
      };

    
    
    return (
        <div className='header-content' data-theme={dark ? "light" : "dark"}>
        
            <label class="swap swap-rotate demo-sticker">
  
  <input type="checkbox" onClick={() => setDark(!dark)} />
  

  <svg style={{color:'#D0D0D0'}} class="swap-off fill-current w-10 h-10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5.64,17l-.71.71a1,1,0,0,0,0,1.41,1,1,0,0,0,1.41,0l.71-.71A1,1,0,0,0,5.64,17ZM5,12a1,1,0,0,0-1-1H3a1,1,0,0,0,0,2H4A1,1,0,0,0,5,12Zm7-7a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V4A1,1,0,0,0,12,5ZM5.64,7.05a1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.41l-.71-.71A1,1,0,0,0,4.93,6.34Zm12,.29a1,1,0,0,0,.7-.29l.71-.71a1,1,0,1,0-1.41-1.41L17,5.64a1,1,0,0,0,0,1.41A1,1,0,0,0,17.66,7.34ZM21,11H20a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Zm-9,8a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0V20A1,1,0,0,0,12,19ZM18.36,17A1,1,0,0,0,17,18.36l.71.71a1,1,0,0,0,1.41,0,1,1,0,0,0,0-1.41ZM12,6.5A5.5,5.5,0,1,0,17.5,12,5.51,5.51,0,0,0,12,6.5Zm0,9A3.5,3.5,0,1,1,15.5,12,3.5,3.5,0,0,1,12,15.5Z"/></svg>

  <svg class="swap-on fill-current w-10 h-10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.64,13a1,1,0,0,0-1.05-.14,8.05,8.05,0,0,1-3.37.73A8.15,8.15,0,0,1,9.08,5.49a8.59,8.59,0,0,1,.25-2A1,1,0,0,0,8,2.36,10.14,10.14,0,1,0,22,14.05,1,1,0,0,0,21.64,13Zm-9.5,6.69A8.14,8.14,0,0,1,7.08,5.22v.27A10.15,10.15,0,0,0,17.22,15.63a9.79,9.79,0,0,0,2.1-.22A8.11,8.11,0,0,1,12.14,19.73Z"/></svg>
  
            </label>
     
            <div  className="header">

            {!isNestedRoute && (
            <ul className="hidden lg:block">
      {location.pathname !== "/dashboard" && (
        <>
          <li className={`icon-box ${active === 'home' ? 'active' : ''}`} onClick={() => handleClick('home')}>
            <AiFillHome className="icon" />
            <Link to="/">Home</Link>
          </li>
          <li className={`icon-box ${active === 'about' ? 'active' : ''}`} onClick={() => handleClick('about')}>
            <FaUserGraduate className="icon" />
            <Link to="/about">About</Link>
          </li>
          <li className={`icon-box ${active === 'portfolio' ? 'active' : ''}`} onClick={() => handleClick('portfolio')}>
            <AiFillMedicineBox className="icon" />
            <Link to="/portfolio">Portfolio</Link>
          </li>
          <li className={`icon-box ${active === 'blog' ? 'active' : ''}`} onClick={() => handleClick('blog')}>
            <FaBlog className="icon" />
            <Link to="/blog">Blog</Link>
          </li>
          <li className={`icon-box ${active === 'contact' ? 'active' : ''}`} onClick={() => handleClick('contact')}>
            <AiFillContacts className="icon" />
            <Link to="/contact">Contact</Link>
          </li>
          <li className={`icon-box ${active === 'dashboard' ? 'active' : ''}`} onClick={() => handleClick('dashboard')}>
            <AiFillDashboard className="icon" />
            <Link to="/dashboard">Dashboard</Link>
          </li>
        </>
      )}
    </ul>
  )}

             
            </div>
      

          <div className="lg:hidden">
          <MobileMenu/>
          </div>
            {children}
        </div>
    );
};

export default Header;